var map = {
	"./chat.svg": 7031,
	"./corporateOrders.svg": 2689,
	"./feedback.svg": 9032,
	"./finance.svg": 3213,
	"./home.svg": 912,
	"./learning.svg": 9907,
	"./loyalty.svg": 1973,
	"./media.svg": 1071,
	"./nomenclature.svg": 4760,
	"./orders.svg": 9342,
	"./products.svg": 3401,
	"./profits.svg": 3098,
	"./projects.svg": 8243,
	"./reports.svg": 5654,
	"./sales.svg": 5003,
	"./schedule.svg": 2198,
	"./settings.svg": 2618,
	"./shop.svg": 4541,
	"./suppliers.svg": 4980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9123;